var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass: "itemChildList p-5 col-xs-12",
      class: { "col-sm-6": !_vm.inCart },
      attrs: { "data-cy": _vm.product.dn },
      on: {
        click: function ($event) {
          return _vm.UiService.go(_vm.cart, _vm.item)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content bg-white flex-between-center h-100 p-15" },
        [
          _c(
            "div",
            { staticClass: "details flex-between-start flex-column h-100" },
            [
              _c(
                "div",
                { staticClass: "title display-5 color-grey6 text-bold mb-5" },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.truncate(_vm.product.dn)) +
                      "\n\t\t\t"
                  ),
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "description display-6 color-grey6" }, [
                _vm._v(_vm._s(_vm.stripHtml(_vm.product.dd))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "priceDetails display-6 flex-start-center flex-wrap",
                },
                [
                  _vm.product.dp
                    ? _c(
                        "div",
                        { staticClass: "price color-1 mr-20 mb-5 text-nowrap" },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm.ShopService.prix(_vm.product.dp, " ")
                              ) +
                              "\n\t\t\t\t"
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.product.Promo ? _c("promo-list-view") : _vm._e(),
                  _vm._v(" "),
                  (_vm.product.allergens && _vm.product.allergens.length) ||
                  (_vm.product.consumables && _vm.product.consumables.length)
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "allergens flex-start-center color-grey1",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.showDetails()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fie-icon_warning-eat fsize-16 mr-5",
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "fsize-12" }, [
                            _vm._v(_vm._s(_vm.infoAllergens(_vm.product))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pic",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.showDetails()
                },
              },
            },
            [
              _vm.product.imt
                ? _c("img", {
                    staticClass: "img-fit img-fluid ml-10",
                    attrs: {
                      src: _vm.UrlService.imagePath(
                        _vm.product.ShopId,
                        _vm.product.imt
                      ),
                      alt: _vm.product.dn,
                    },
                    on: {
                      error: function ($event) {
                        $event.target.src = "dist/assets/no-img.png"
                      },
                    },
                  })
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }